// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DomUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Find parent node that has scrollbars
 * @param  {DOMElement} node DOM element to check
 */
function findScrollableParent(node: any): any {
  while (node && node.parentNode) {
    node = node.parentNode;

    if (node === document) {
      // This particular node does not have a computed style.
      continue;
    }

    if (node === document.documentElement) {
      // This particular node does not have a scroll bar, it uses the window.
      continue;
    }

    if (node instanceof DocumentFragment) {
      continue;
    }

    const style = window.getComputedStyle(node);
    const overflowY = style.getPropertyValue('overflow-y') || style.getPropertyValue('overflow');

    if (overflowY === 'auto' || overflowY === 'scroll') {
      return node;
    }
  }
  return null;
}

/**
 * Detect collision between 2 DOM element node
 * @return {Boolean}       Whether collide or not
 */
function isNodeCollided(nodeA: any, nodeB: any): boolean {
  const topA = nodeA.offsetTop;
  const leftA = nodeA.offsetLeft;
  const rightA = leftA + nodeA.offsetWidth;
  const bottomA = topA + nodeA.offsetHeight;

  const topB = nodeB.offsetTop;
  const leftB = nodeB.offsetLeft;
  const rightB = leftB + nodeB.offsetWidth;
  const bottomB = topB + nodeB.offsetHeight;

  return !(topA >= bottomB || rightA <= leftB || bottomA <= topB || leftA >= rightB);
}

function findRelativePositionToAcesstor(child: any, ancestor: any): any {
  const childPosition = $izenda(child).offset();
  const ancestorPosition = $izenda(ancestor).offset();

  return {
    top: childPosition.top - ancestorPosition.top,
    left: childPosition.left - ancestorPosition.left
  };
}

export default {
  isNodeCollided,
  findScrollableParent,
  findRelativePositionToAcesstor
};



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.DomUtils.js